import React, { useState, useEffect } from "react";
// styles
import "../pages.css";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { tiposDeDevice as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoTiposDeDevice as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { tiposDeDeviceGet } from '../../services/hooli-services/TiposDeDevice/TiposDeDeviceGet';
// recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function TiposDeDevice() {
    const [tiposDeDevice, setTiposDeDevice] = useState([]);
    const [rows, setRows] = useState([]);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const setRow = useSetRecoilState(rowSelected)
    const credentials = useRecoilValue(userCredentials);
    const setFormInfo = useSetRecoilState(formData);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, tiposDeDeviceGet, setTiposDeDevice)
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        tiposDeDevice.map((item) => {
            const {
                tipoDeviceId,
                tipoDeviceNombre,
                tipoDeviceCod,
                tipoDeviceVersion,
            } = item

            const device = {
                id: tipoDeviceId,
                version: tipoDeviceVersion,
                [titles[0]]: tipoDeviceNombre,
                [titles[1]]: tipoDeviceCod,
            }

            setRows(rows => [...rows, device])
            return item
        });
    }, [tiposDeDevice]);

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="tipo de device" handleClick={handleClick} updateList={updateList} />
            <div className="row-grid" >
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main>
    )
};